/*** IMPORTS FROM imports-loader ***/
var global = window;

export { unstable_batchedUpdates } from 'react-dom';
